const appendWithString = (str: string, appendWith: string, condition: boolean) =>
  condition ? `${appendWith} ${str}` : str;

export default appendWithString;
